const PREFIX = "Shared/Unit/";

export const RECEIVE_UNIT = `${PREFIX}RECEIVE_UNIT`;
export const RECEIVE_UNITS = `${PREFIX}RECEIVE_UNITS`;
export const RECEIVE_UNITS_TABLE = `${PREFIX}RECEIVE_UNITS_TABLE`;
